module.exports = __webpack_public_path__ + "static/media/cancel_order_button_grey.0062a3fa.svg";